import React, { useState } from "react";

import './ProjectContainer.css';

import openLinkInNewTab from "../Functions";

// Project container for viewing completed projects in the /projects route
// Takes: title, date, languages, description, canView, showMore, setShowMore, logoSrc, logoAlt
export default function ProjectContainer(props) {
    const [viewMoreisHovered, setViewMoreIsHovered] = useState(false);
    const [viewProjectButtonIsHovered, setViewProjectButtonIsHovered] = useState(false);

    const renderViewMore = () => {
        if (props.viewMore) {
            return (
                <>
                    <img className="project-button-image"
                        src={viewMoreisHovered ? '/images/view-more-button-selected.png' :
                            '/images/view-more-button.png'}

                        alt={viewMoreisHovered ? "hovered view more pixel art button" : "view more pixel art button"}
                        onMouseEnter={() => setViewMoreIsHovered(true)}
                        onMouseLeave={() => setViewMoreIsHovered(false)}
                        onClick={() => {
                            if (props.showMore) {
                                props.setShowMore(false);
                            } else {
                                props.setShowMore(true);
                            }

                        }} />

                    <h2 className="project-buttons-or-text">Or</h2>
                </>
            )
        }
    }

    const renderViewButton = () => {
        if (props.canView) {
            if (props.isWebsite) {
                return (
                    <img className="project-button-image"
                        src={viewProjectButtonIsHovered ? '/images/visit-website-button-selected.png' :
                            '/images/visit-website-button.png'}

                        alt={viewProjectButtonIsHovered ? "hovered visit website pixel art button" : "view visit website pixel art button"}
                        onMouseEnter={() => setViewProjectButtonIsHovered(true)}
                        onMouseLeave={() => setViewProjectButtonIsHovered(false)}
                        onClick={() => openLinkInNewTab(props.projectHref)}
                    />
                )
            } else {
                return (
                    <img className="project-button-image"
                        src={viewProjectButtonIsHovered ? '/images/view-project-button-selected.png' :
                            '/images/view-project-button.png'}

                        alt={viewProjectButtonIsHovered ? "hovered view project pixel art button" : "view project pixel art button"}
                        onMouseEnter={() => setViewProjectButtonIsHovered(true)}
                        onMouseLeave={() => setViewProjectButtonIsHovered(false)}
                        onClick={() => openLinkInNewTab(props.projectHref)} 
                        />
                )

            }
        } else {
            return (
                <img className="project-button-image"
                    src={'/images/unavailable-button.png'}
                    alt={"unavailable pixel art button"} />
            )
        }
    }

    return (
        <>
                                <h1 className={'project-title ' + props.titleColorClass} color={props.titleColor}>{props.title}</h1>
            <div className="project-container">
                <div className="project-container-left">
                    <div className="project-titles-container">

                        <h2 className="project-subtitle">{props.date}</h2>
                        <h2 className="project-subtitle">{props.languages}</h2>
                    </div>

                    <div className="project-description-container">
                        <p className="project-description">{props.description}</p>
                    </div>

                    <div className="project-buttons-container">
                        {renderViewMore()}

                        {renderViewButton()}
                    </div>

                </div>

                <div className="project-container-right">

                    <img className={props.projectImage ? props.longImage ? "long-project-image" : "project-image" : 'project-logo-image'} src={props.logoSrc} alt={props.logoAlt} />

                </div>
            </div>
        </>
    )
}